export default "__VITE_ASSET__1688cc90__"